import "../../css/footer.css";
import "../../css/container.css";
import "../../css/fonts.css";
import { FooterLinksLocalRest } from "./footer.links.rest";
import { FooterLinksLocalContact } from "./footer.links.contact";
import { useIsMobile } from "../../hooks/is.mobile";
export const FooterLinksLocal = () => {
  const isMobile = useIsMobile();
  return (
    <div style={{ padding: "10%" }}>
      <div className="footer-links-local-container">
        {isMobile ? "" : <FooterLinksLocalRest />}
        <FooterLinksLocalContact />
        {isMobile ? <FooterLinksLocalRest /> : ""}
      </div>
    </div>
  );
};
